import { ConsumerSearchHit, Hits } from 'search/components/ProductHits'

type TrendingProductsProps = {
  hidePrices: boolean
  hits?: ConsumerSearchHit[]
}

export const TrendingProducts = ({ hidePrices, hits }: TrendingProductsProps) => {
  if (!hits) return null
  return <Hits hidePrices={hidePrices} hits={hits} />
}

export default TrendingProducts
